import React, { useEffect, useState } from 'react';
import { push } from 'redux-first-history';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import ProfileTab from './ProfileTab';
import ChallengeTab from './ChallengeTab';
import ExerciseTab from './ExerciseTab';
import FriendsTab from './FriendsTab';
import CurvedContainer from '../../components/CurvedContainer';
import * as actions from './actions';
import { useActions } from 'hooks/useActions';
import { hexToRgb } from 'functions/colorFunctions';
import { Images } from 'util/images';
import { colors } from 'global/colors';
import { useQueryParams } from 'hooks/useQueryParams';
import { Wrapper } from '../../components';
import { TabContainer, TabTitle, TabIcon, Link } from './styles';

export const getTrophyStyle = (trophy) => {
  const getDescription = (medal, fiftyLimit, hundredLimit, fiveHundredLimit, thousandLimit, aboveLimit) =>
    `Number of ${medal} medals distributed per participant:<br/>` +
    `${fiftyLimit} for between 1 and 50<br/>` +
    `${hundredLimit} for between 51 and 100<br/>` +
    `${fiveHundredLimit} for between 101 and 500<br/>` +
    `${thousandLimit} for between 501 and 1000<br/>` +
    `${aboveLimit} for above 1000`;

  let color, icon, description;
  switch (trophy) {
    case 'gold':
      color = hexToRgb(colors.gold);
      description = getDescription('gold', 1, 2, 10, 20, 40);
      break;
    case 'silver':
      color = hexToRgb(colors.silver);
      description = getDescription('silver', 2, 5, 25, 50, 100);
      break;
    case 'bronze':
      color = hexToRgb(colors.bronze);
      description = getDescription('bronze', 5, 10, 50, 100, 200);
      break;
    case 'top10':
      color = hexToRgb(colors.darkBlue);
      icon = '\f005';
      description = 'Top 10 winners will get this trophy';
      break;
    default:
      color = hexToRgb(colors.lightGreen);
      icon = '\f21e';
      description = getDescription('iron', 10, 20, 100, 200, 400);
      break;
  }

  return { color, icon, description };
};

export default React.memo(({ match }) => {
  const { userId } = useSelector((state) => state.auth);

  const { id: profileId } = useQueryParams();
  const { subpage = '' } = match.params;

  const { goToAchievements } = useActions({
    goToAchievements: () => push(`/profile/achievements?id=${profileId || userId}`),
  });

  const { goToXP } = useActions({
    goToXP: () => push(`/profile/xp?id=${profileId || userId}`),
  });

  const { getProfile, updateUser, setProfile } = useActions(actions);

  // TODO do not select state conditionally.
  const { profile, error } = useSelector((state) =>
    profileId && profileId !== userId ? state.userProfile : state.profile
  );

  const [isOwnProfile, setIsOwnProfile] = useState(false);

  useEffect(() => {
    getProfile(profileId !== userId ? profileId : null);
  }, [getProfile, profileId, userId]);

  useEffect(() => {
    if (userId === profile?._id) {
      setIsOwnProfile(true);
      window.history.replaceState(null, '', `?id=${profile._id}`);
    }
  }, [userId, profile]);

  const renderTab = (tab) => {
    switch (tab) {
      case '':
        return (
          <ProfileTab
            setProfile={setProfile}
            updateUser={updateUser}
            goToAchievements={goToAchievements}
            goToXP={goToXP}
            profile={profile}
            hideEditButton={!isOwnProfile}
          />
        );
      case 'challenges':
        return <ChallengeTab profile={profile} userId={profileId} />;
      case 'exercises':
        return <ExerciseTab profile={profile} userId={profileId} />;
      case 'friends':
        return <FriendsTab profile={profile} />;
      default:
        return null;
    }
  };

  return (
    <Wrapper color="transparent">
      <CurvedContainer bottom image={Images.tanks} height={110} />
      {error && <Redirect to="/notFound" />}
      {/* TODO: Bring back when the profile tab has data for experience, level etc. and friends are available.
          also remove <ChallengeTab/> from ProfileTab.js and restore the original route in router.js
          and restore experience percent and progress bar to Header/index.js */}
      {profile && (
        <>
          <TabContainer>
            <TabTitle isActive={subpage === ''}>
              <Link to={`/profile?id=${profileId || userId}`}>
                <TabIcon icon="\f015" />
                Profile
              </Link>
            </TabTitle>
            <TabTitle isActive={subpage === 'challenges'}>
              <Link to={`/profile/challenges?id=${profileId || userId}`}>
                <TabIcon icon="\f121" />
                Challenges
              </Link>
            </TabTitle>
            <TabTitle isActive={subpage === 'exercises'}>
              <Link to={`/profile/exercises?id=${profileId || userId}`}>
                <TabIcon icon="\f121" />
                Exercises
              </Link>
            </TabTitle>
            {/* <TabTitle isActive={subpage === "friends"}>
          <Link to="/profile/friends">
            <TabIcon icon="\f0c0" />
            Friends
          </Link>
        </TabTitle> */}
          </TabContainer>
          {renderTab(subpage)}
        </>
      )}
    </Wrapper>
  );
});
